export const apiCreate = (): string => '/partnerships/agencies/'
export const apiList = (id?: string): string =>
  !id ? '/partnerships/agencies/' : `/partnerships/agencies/view/${id}`
export const apiGetByIdUpdatePage = (id: string): string =>
  `/partnerships/agencies/getByIdUpdatePage/${id}`
export const apiUpdate = (id: string): string =>
  `/partnerships/agencies/update/${id}`
export const apiDelete = (id: string): string => `/partnerships/agencies/${id}`

export const listAgenciesByPromoterOptions = (promoter_id: string): string =>
  `/partnerships/agencies/options?promoter_id=${promoter_id}`
